import {
  getPriceOfMainProduct,
  getPricingObject,
  getPricingProductByVariantId,
} from "./product";
import { getSelectedValueByFieldsetElementOrNull } from "@surf-turf/nemo/assets/utils-product";
import { pricing } from "../utils/pricing";

const controlBarElement = document.querySelector("control-bar");
const productForm = document.querySelector("product-form");
const overviewHolderElement =
  controlBarElement.querySelector(".overview-holder");
const productsHolderElemnt =
  overviewHolderElement.querySelector(".products-holder");
const propertiesHolderElement = controlBarElement.querySelector(
  ".product-properties"
);

/**
 * Handle connected products in control bar.
 */
export const handleConnectedProductsInControlBar = () => {
  const allConnectedProductsInControlBar =
    productsHolderElemnt.querySelectorAll(".connected-product");
  const arrayOfAllConnectedProducts = [...allConnectedProductsInControlBar];
  const pricingObject = getPricingObject();

  if (pricingObject.connectedProductsPrice) {
    arrayOfAllConnectedProducts.map((connectedProduct, index) => {

      const connectedProductId = connectedProduct.dataset.connectedProductId;

      const connectedProductPricingHolder =
        connectedProduct.querySelector(".price");
      const connectedProductElement = productForm.querySelector(
        `connected-product.${connectedProductId}`
      );
      const sizeFieldsetElement =
        connectedProductElement.querySelector(".property--size");
      const selectedInput = sizeFieldsetElement.querySelector("input:checked");
      const value = selectedInput?.value;
      const price = pricingObject.connectedProductsPrice[index].price;

      if (value) {
        connectedProduct.querySelector(".selected-value").innerHTML = value;
      }

      if (price) {
        // Set pricing
        connectedProductPricingHolder.innerHTML = pricing(price).replace(
          ".00",
          " "
        );
      } else {
        connectedProductPricingHolder.innerHTML = "None";
      }
    });
  }
};

export const updateSetSizeInControlBar = () => {
  const sizeFieldsetElement = productForm.querySelector(
    'fieldset[name="size"]'
  );
  const selectedValue = sizeFieldsetElement
    ? getSelectedValueByFieldsetElementOrNull(sizeFieldsetElement)
    : null;
  const sizeElement = productsHolderElemnt.querySelector(
    ".products-holder__size .selected-value"
  );
  if (selectedValue && sizeElement) {
    sizeElement.innerHTML = selectedValue ;
  }
};


/**
 * Handle add on in control bar.
 *
 * This sets the price of the add on in the control bar
 */
export const handleAddOnInControlBar = () => {
  const mainProductPrice = getPriceOfMainProduct();
  const AddOnPricingHolder =
    productsHolderElemnt.querySelector(".add-on-price");

  if (mainProductPrice) {
    // Set pricing

    // console.log(pricing(mainProductPrice.price));

    if (pricing(mainProductPrice.price).includes("NOK")) {
      AddOnPricingHolder.innerHTML = pricing(mainProductPrice.price);
    } else {
      AddOnPricingHolder.innerHTML = pricing(mainProductPrice.price).replace(
        ".00",
        " "
      );
    }
  } else {
    AddOnPricingHolder.innerHTML = null;
  }
};

/**
 * Update quantity.
 * Get the pairing fielset and update the quantity with the fielset selected value.
 */
export const updateQuantity = () => {
  const pairingFieldsetElement = productForm.querySelector(
    'fieldset[name="pairing"]'
  );
  const quantityFieldsetElement = productForm.querySelector(
    'fieldset[name="quantity"]'
  );

  // If there is no pairing fieldset or quantity fieldset element, return single and end function.
  if (!pairingFieldsetElement && !quantityFieldsetElement) {
    return "single";
  }

  // Check if the pairing fieldset element exists if not, then us the quantity fieldset element.
  const correctFieldsetElement = pairingFieldsetElement
    ? pairingFieldsetElement
    : quantityFieldsetElement;
  const selectedValue = getSelectedValueByFieldsetElementOrNull(
    correctFieldsetElement
  );

  // Update label according to selected value.
  const quantityLabel = propertiesHolderElement.querySelector(
    ".product-properties__quantity .quantity-label"
  );

  if (selectedValue === "left" || selectedValue === "right") {
    quantityLabel.innerHTML = "Side";
  } else {
    quantityLabel.innerHTML = "Quantity";
  }

  const quantityElement = propertiesHolderElement.querySelector(
    ".product-properties__quantity .selected-value"
  );

  if (selectedValue) {
    quantityElement.innerHTML = selectedValue;
  }
};

/**
 * Update color.
 * Get the color fielset and update the color with the fielset selected value.
 */
export const updateColor = () => {
  const colorFieldsetElement = productForm.querySelector(
    'fieldset[name="color"]'
  );
  const selectedValue = colorFieldsetElement
    ? getSelectedValueByFieldsetElementOrNull(colorFieldsetElement)
    : null;
  const colorElement = propertiesHolderElement.querySelector(
    ".product-properties__color .selected-value"
  );

  if (selectedValue) {
    colorElement.innerHTML = selectedValue;
  }
};
